import React from "react";
import { useAppState } from "../../../context/StateContext";
import { useQuickOrderFeature } from "Hooks/useQuickOrderFeature";
import Unauthorized from "../../Unauthorized";
import { checkResourceCan, FN_NAMES, hasPermission } from "Util/permissions";
import { ResourceCanEnum } from "Util/enums/accessRule";
import { ResourceName } from "Util/enums";

import Orders from "../../Orders";
import OrdersMnt from "../../Orders/Maintenance";

import OperationOrders from "../../../pages/private/Moving/Operations";
import OperationOrdersMnt from "../../../pages/private/Moving/Operations/Maintenance";

const OrdersWrapper = () => {
  const { currentUser } = useAppState();

  return currentUser?.company?.profileId === 3 || currentUser?.company?.profileId === 6 ? (
    <OperationOrders />
  ) : (
    <Orders />
  );
};

const OrdersMaintenanceWrapper = (props: any) => {
  const { currentUser } = useAppState();

  return currentUser?.company?.profileId === 3 || currentUser?.company?.profileId === 6 ? (
    <OperationOrdersMnt {...props} />
  ) : (
    <OrdersMnt {...props} />
  );
};

const QuickOrderWrapper = (props: any) => {
  const { currentUser, userPermissions } = useAppState();
  const { quickOrderEnabled, isLoadingQuickOrderFlags } = useQuickOrderFeature();

  if (isLoadingQuickOrderFlags) {
    return null;
  }

  const isMovingCompany = currentUser?.company?.profileId === 3 || currentUser?.company?.profileId === 6;
  if (!isMovingCompany || !quickOrderEnabled) {
    return <Unauthorized />;
  }

  const canCreateOrder =
    checkResourceCan(userPermissions ?? [], ResourceName.ORDERS, ResourceCanEnum.EDIT) &&
    hasPermission(userPermissions ?? [], FN_NAMES.FUNCTION_OPERATIONS_ORDERS_ADD_NEW);

  if (!canCreateOrder) {
    return <Unauthorized />;
  }

  return <OperationOrdersMnt {...props} quickOrderMode />;
};

export { OrdersWrapper, OrdersMaintenanceWrapper, QuickOrderWrapper };
